import { api } from '@api'
import { AssignmentZone } from '@types'

interface AssignmentZoneResponse {
  zones: AssignmentZone[]
}

const getAssignmentZones = async () => {
  const response = await api.get<AssignmentZoneResponse>('/assignment-zones')

  return response.data.zones
}

export const AssignmentZonesApi = { getAssignmentZones }
